import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";

const TESTIMONIALS = [
  {
    quote: "I was in an auto/techno bind with my RX 350 frozen in my garage. I could not get even a spark of life from it. I was at my wits end. Tried several mobile mechanics and they made appts. and didn't show. Then I found Gerron! He was punctual, thoughtful and engaging. He did the trouble shoot and had the issue isolated in 30 minutes. Once realizing the two year old battery wasn't holding a charge, he took the battery to AutoZone, purchased a new one, installed and I was good to go. Two hours for $327. The best money I have spent in years.",
    name: "Marilyn H.",
    detail: "RX 350 Owner",
  },
  {
    quote: "I called Gerron on a Saturday with the hope of getting a call back the next week. I just needed a flat repair on my dump trailer. He called back within five minutes and had the repair finished less than two hours later. Amazing service and awesome job. Thank you!",
    name: "Joe B.",
    detail: "Dump Trailer Repair",
  },
  {
    quote: "Gerron was friendly, arrived on time, and completed the repair according to the estimate. Highly recommended!",
    name: "Anthony W.",
    detail: "Happy Customer",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.15 },
  }),
};

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-card">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="uppercase text-xs tracking-[0.2em] text-muted-foreground font-medium mb-4"
        >
          Customer Reviews
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-16 max-w-xl"
        >
          Don't take our word for it. <span className="text-primary">Hear from our community.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={cardVariants}
              className="bg-background border border-stone-200 rounded-xl p-8 md:p-10 flex flex-col justify-between group hover:border-primary/30 transition-colors duration-300"
              data-testid={`testimonial-card-${i}`}
            >
              <div>
                <Quotes weight="fill" className="w-8 h-8 text-primary/30 mb-4" />
                <p className="text-foreground leading-relaxed text-sm md:text-base mb-6">
                  "{t.quote}"
                </p>
              </div>
              <div className="flex items-center justify-between pt-6 border-t border-stone-200">
                <div>
                  <p className="font-heading font-bold text-sm">{t.name}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{t.detail}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} weight="fill" className="w-4 h-4 text-amber-400" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Average rating banner */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-center"
        >
          <div className="flex gap-1">
            {[...Array(5)].map((_, j) => (
              <Star key={j} weight="fill" className="w-5 h-5 text-amber-400" />
            ))}
          </div>
          <p className="text-muted-foreground text-sm">
            <span className="font-heading font-bold text-foreground">4.8 out of 5</span> — based on Hillsboro community reviews
          </p>
        </motion.div>
      </div>
    </section>
  );
}
